<template>
    <b-container>
        <b-row v-if="success" class="text-center pt-4">
            <b-col>
                <b-alert show variant="success">
                    <p>{{ $t("info.successgeneric") }}</p>
                </b-alert>
            </b-col>
        </b-row>
        <b-form v-else @submit="onSubmit">
            
            <b-alert show variant="info">
                <div>{{ form.NOMDIV }}</div>
                <div>{{ form.YEAR }}</div>
            </b-alert>

            <b-row v-if="form" class="mt-2">
                <b-col>
                    <strong>JAN</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.JAN"></b-form-input>
                </b-col>
                <b-col>
                    <strong>FEB</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.FEB"></b-form-input>
                </b-col>
                <b-col>
                    <strong>MARCH</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.MARCH"></b-form-input>
                </b-col>
                <b-col>
                    <strong>APRIL</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.APRIL"></b-form-input>
                </b-col>
            </b-row>

            <b-row v-if="form" class="mt-2">
                <b-col>
                    <strong>MAY</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.MAY"></b-form-input>
                </b-col>
                <b-col>
                    <strong>JUNE</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.JUNE"></b-form-input>
                </b-col>
                <b-col>
                    <strong>JULY</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.JULY"></b-form-input>
                </b-col>
                <b-col>
                    <strong>AUGUST</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.AUGUST"></b-form-input>
                </b-col>
            </b-row>

            <b-row v-if="form" class="mt-2">
                <b-col>
                    <strong>SEPT</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.SEPT"></b-form-input>
                </b-col>
                <b-col>
                    <strong>OCT</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.OCT"></b-form-input>
                </b-col>
                <b-col>
                    <strong>NOV</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.NOV"></b-form-input>
                </b-col>
                <b-col>
                    <strong>DECEMBER</strong>
                    <b-form-input type="number" min="0" max="1000" v-model="form.DECEMBER"></b-form-input>
                </b-col>
            </b-row>

            <b-button class="mt-4 text-center" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit")
            }}</b-button>

            <div v-if="error" class="pt-4">
                <b-alert show variant="info">
                    <p>{{ error }}</p>
                </b-alert>
            </div>

            <div v-if="spinner" class="text-center align-middle">
                <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
                    disabled="labelStatus"></b-spinner>
            </div>
        </b-form>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
    mixins: [globalF],
    props: ["budget"],
    data() {
        return {
            form: this.getData(),
            spinner: false,
            disabled: false,
            error: "",
            success: false,
        };
    },
    computed: {
        url: function () {
            return this.getUrl();
        },
    },
    methods: {
        getData: function () {
            return this.budget;
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.error = "";
            this.spinner = true;
            this.form.request = this.budget.request;//"editBudget";

            axios
                .post(this.url, this.form, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.disabled = false;
                    this.spinner = false;
                    this.success = true;
                })
                .catch(() => {
                    this.error = this.$t("info.errorgeneric");
                    this.disabled = false;
                    this.spinner = false;
                });
        },
    },
};
</script>
  